module.exports = __webpack_public_path__ + "img/history-order-empty.92b0dc1.webp";